import type { ComponentProps } from 'react';
import { cn } from '@/shared/lib';
import { textareaClasses } from './fieldStyles';

export type TextareaProps = ComponentProps<'textarea'>;

export function Textarea({ className, ...props }: TextareaProps) {
  return <textarea className={cn(textareaClasses, className)} {...props} />;
}
